import { Component } from '@angular/core';

@Component({
  selector: 'cdp-icons',
  templateUrl: './icons.svg.html',
  styleUrls: ['./icons.scss'],
})
export class CdpIconsComponent {
}
